export default __webpack_public_path__ + "static/transforming-kyc-experience-for-banks-cf29c76c16cc8b2f0e4138f75aff2faa.png";